<template>
    <div class="analytics-correctness-periodic">
        <span class="analytics-correctness-periodic__art"></span>

        <div class="analytics-correctness-periodic__wr-periods">
            <div class="analytics-correctness-periodic__current-period"
                :class="changeClass">
                <span class="analytics-correctness-periodic__current-period-icon"></span>
                <div class="analytics-correctness-periodic__wr-current-period">
                    <div
                        v-if="showPreloader"
                        class="analytics-correctness-periodic__preloader"></div>
                    <template v-if="!showPreloader">
                        <span class="analytics-correctness-periodic__wr-current-period-value">
                            <span class="analytics-correctness-periodic__current-period-value">%{{ filteredCorrectnessPeriodicData.current.value }}</span>
                            <span class="analytics-correctness-periodic__current-period-change">%{{ filteredCorrectnessPeriodicData.current.change }}</span>
                        </span>
                        <span class="analytics-correctness-periodic__current-period-label">{{ textCurrentPeriodLabel }}</span>
                    </template>
                </div>
            </div>

            <div class="analytics-correctness-periodic__previous-period">
                <div class="analytics-correctness-periodic__wr-previous-period">
                    <div    
                        v-if="showPreloader"
                        class="analytics-correctness-periodic__preloader"></div>
                    <template v-if="!showPreloader">
                        <span class="analytics-correctness-periodic__previous-period-value">%{{ filteredCorrectnessPeriodicData.previous.value }}</span>
                        <span class="analytics-correctness-periodic__previous-period-label">{{ textPreviousPeriodLabel  }}</span>
                    </template>
                </div>
                <span class="analytics-correctness-periodic__previous-period-icon"></span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                showPreloader: true,
            };
        },

        computed: {
            filteredCorrectnessPeriodicData(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsCorrectness.correctnessPeriodic.type;
                return this.$store.state.response.analyticsCorrectness.correctnessPeriodicData[selectedFiltertagType];
            },

            changeClass(){
                if(this.showPreloader){return '';}
                return this.filteredCorrectnessPeriodicData.current.change > 0 ? '' : 'analytics-correctness-periodic__current-period--change-negative';
            },

            textCurrentPeriodLabel(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsCorrectness.correctnessPeriodic.type;
                if(selectedFiltertagType === 'weekly'){
                    return 'bu hafta: ' + this.filteredCorrectnessPeriodicData.current.period;
                }
                else if(selectedFiltertagType === 'monthly'){
                    return 'bu ay: ' + this.filteredCorrectnessPeriodicData.current.period;
                }
                else if(selectedFiltertagType === 'yearly'){
                    return 'bu yıl: ' + this.filteredCorrectnessPeriodicData.current.period;
                }
            },

            textPreviousPeriodLabel(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsCorrectness.correctnessPeriodic.type;
                if(selectedFiltertagType === 'weekly'){
                    return 'önceki hafta: ' + this.filteredCorrectnessPeriodicData.previous.period;
                }
                else if(selectedFiltertagType === 'monthly'){
                    return 'önceki ay: ' + this.filteredCorrectnessPeriodicData.previous.period;
                }
                else if(selectedFiltertagType === 'yearly'){
                    return 'önceki yıl: ' + this.filteredCorrectnessPeriodicData.previous.period;
                }
            },
        },

        mounted(){
            if(this.$store.state.envDev){
                this.showPreloader = true;
                fetch(this.$store.state.jsonServer.analyticsCorrectnessPeriodic)
                .then(response => response.json())
                .then(correctnessPeriodicData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsCorrectness',
                        dataLabel: 'correctnessPeriodicData',
                        data: correctnessPeriodicData
                    });
                    this.showPreloader = false;
                });
            }
            else{
                this.showPreloader = true;
                fetch(this.$store.state.api.analyticsCorrectnessCorrectnessPeriodic, {
                    method: 'GET',
                    credentials: 'include'
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(correctnessPeriodicData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsCorrectness',
                        dataLabel: 'correctnessPeriodicData',
                        data: correctnessPeriodicData
                    });
                    this.showPreloader = false;
                })
                .catch(err => {
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                    console.error(err);
                });
            }
        }
    };
</script>
<style scoped src="@/css/components/analytics-correctness-periodic.css"></style>